import { gql } from '@apollo/client';
import { CartInfoShared } from '../fragments';

export default gql`
  query adminCart($id: ID!) {
    adminCart(id: $id) {
      ...CartInfoShared
    }
  }
  ${CartInfoShared}
`;
